import { useEffect, useState, useCallback } from 'react';
import { fetchMaquinas } from '../../services/maquinaService';
import { Maquina } from '../../interfaces/maquina.interface';

const useFetchMaquinas = () => {
    const [maquinas, setMaquinas] = useState<Maquina[]>([]);
    const [loadingMaquinas, setLoadingMaquinas] = useState(true);
    const [errorMaquinas, setErrorMaquinas] = useState<string | null>(null);

    const refetchMaquinas = useCallback(async () => {
        setLoadingMaquinas(true);
        try {
            const data = await fetchMaquinas();
            setMaquinas(data);
        } catch (err) {
            setErrorMaquinas('Falha ao buscar máquinas');
        } finally {
            setLoadingMaquinas(false);
        }
    }, []);

    useEffect(() => {
        refetchMaquinas();
    }, [refetchMaquinas]);

    return { maquinas, loadingMaquinas, errorMaquinas, refetchMaquinas };
};

export default useFetchMaquinas;
